import {BASE_ADMIN_API, fetchAPI} from '@/services/api';
import type {ResponsePage} from '@/services/page.interface';

export interface TaxRepPageBO {
    pageSize: number;
    pageNumber: number;
    pageType: number;
    taxRepName?: string;
}

export interface TaxRepBO {
    id?: number;
    taxRepName?: string;
    telephone?: string;
    herebyAuthorize?: string;
    address?: string;
    brNumber?: string;
}

export interface TaxRepVO {
    id: number;
    taxRepName?: string;
    telephone?: string;
    herebyAuthorize?: string;
    address?: string;
    brNumber?: string;
}

const base = `${BASE_ADMIN_API}/tax-rep`;

export async function getById(id: number) {
    return fetchAPI<TaxRepVO>(`${base}/get?id=${id}`, {method: 'GET'});
}

export async function queryPage(pageBO: TaxRepPageBO) {
    return fetchAPI<ResponsePage<TaxRepVO>>(`${base}/queryPage`, {
        method: 'POST',
        body: JSON.stringify(pageBO),
    });
}

export async function querySelectionList() {
    return fetchAPI<TaxRepVO[]>(`${base}/querySelectionList`, {method: 'POST'});
}

export async function create(bo: TaxRepBO) {
    return fetchAPI<TaxRepVO>(`${base}/create`, {
        method: 'POST',
        body: JSON.stringify(bo),
    });
}

export async function update(id: number, bo: TaxRepBO) {
    return fetchAPI<TaxRepVO>(`${base}/update/${id}`, {
        method: 'POST',
        body: JSON.stringify(bo),
    });
}

export async function deleteById(id: number) {
    return fetchAPI<void>(`${base}/delete/${id}`, {method: 'POST'});
}

/** Upsert by taxRepName (is_del=0): update if exists, else create. */
export async function saveOrUpdateByName(bo: TaxRepBO) {
    return fetchAPI<TaxRepVO>(`${base}/saveOrUpdateByName`, {
        method: 'POST',
        body: JSON.stringify(bo),
    });
}

export const TaxRepService = {
    getById,
    queryPage,
    querySelectionList,
    create,
    update,
    deleteById,
    saveOrUpdateByName,
};
